"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageContextProvider = exports.PageContext = void 0;
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const web_i18n_1 = require("@snapchat/web-i18n");
const react_1 = require("react");
const web_headers_1 = require("@snapchat/web-headers");
exports.PageContext = (0, react_1.createContext)({
    locale: web_i18n_1.DEFAULT_LOCALE,
    isMobile: true,
    webClientId: undefined,
    pageType: web_blizzard_reporting_1.PageType.UNSET,
    country: web_headers_1.INVALID_COUNTRY_CODE,
    traceId: "",
    authStateObservable: undefined,
    isGdprCountry: true,
});
exports.PageContextProvider = exports.PageContext.Provider;
//# sourceMappingURL=pageContext.js.map